import React, { useCallback, useEffect, useState } from "react";
import { Pressable, Text, View, ScrollView, FlatList } from "react-native";

import { debounce } from "lodash";
import { store } from "../../store/store";

import { checkIfShowA2shBtn } from "../../utils/services/A2HSUtils";
import { hasChemistProfilePic } from "../../utils/services/chemist/ChemistStoreUtils";
import { mergeDealListWithCartData, upsertCartItem } from "../../utils/services/oms/OMSCartUtils";
import { MoengageEvents, trackMoengageEvents } from "../../utils/services/webapp-services/MoengageUtils";
import { pickPrescriptionImageByCamera, pickPrescriptionImageByGallery } from "../../utils/services/ImagePickerUtils";
import { getSelectedLocationTitle, getStringWithItemCount, isChemistStoreLoaded, isObjectNotEmpty } from "../../utils/services/CommonUtils";

import { View as AnimatableView } from "react-native-animatable";
import { CommonZeroScreen } from "../zero-screens/CommonZeroScreen";
import { HorizontalDivider } from "../../utils/widgets/Common-Widget";
import { PrimaryCTA, SecondaryCTA } from "../../utils/widgets/CommonCTA";
import { CommonLocationHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { ChemistDashboardShimmer } from "../shimmer-component/ChemistDashboardShimmer";
import { AdPosterView, AdPosterPaginationView } from "../../utils/widgets/AdPosterView";
import { DownChevron, IconView, SeeAllIcon } from "../../utils/widgets/CommonWidget/Icons";
import { GetProductCategories } from "../../utils/services/inventory/FilterProductCategories";
import { ProductCategoriesListView } from "../../utils/widgets/Inventory/ProductCategoriesListView";
import { ChemistSiteLogo, ChemistStorePicture } from "../../utils/widgets/chemist/ChemistStoreWidget";

import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";
import { minDealsToShowAllBtn } from "../../utils/constants/AppConstants";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

import DealView from "../../utils/widgets/deals/DealView";
import PhotoCaptureModel from "../../utils/modals/PhotoCaptureModal";
import FadeTextList from "../../utils/widgets/Animations/FadeTextList";
import CustomCarousel from "../../utils/widgets/Carousel/CustomCarousel";
import A2HSDashboardView from "../../utils/widgets/A2HS/A2HSDashboardView";

const ChemistStoreComponent = (props) => {

    global.windowScrollListPageYOffset = 0
    global.allowScrollChemistComponent = false

    const reduxState = store.getState()

    const chemistStoreLoaded = isChemistStoreLoaded()

    const selectedLocation = props?.selectedLocation ?? {}

    const [isShowA2hsCta, setIsShowA2hsCta] = useState(false)

    const [chemistComponentInitialised, setComponentInitialised] = useState(false)

    const [chemistStoreData, setChemistStoreData] = useState(reduxState.pharmacyAllData)

    const [chemistAdPosterData, setChemistAdPosterData] = useState([])

    const [dealsData, setDealsList] = useState({
        deals: null, inventoryCount: 0
    })

    const [productCategories, setProductCategories] = useState([])

    const [photoCaptureModal, setPhotoCaptureModal] = useState(false)

    useEffect(() => {
        if (!chemistComponentInitialised) {
            setComponentInitialised(true)
            chemistStoreSubscription()
            store.subscribe(() => {
                chemistStoreSubscription()
                // chemistComponentOnFocus()
            })
        }
        if (chemistStoreLoaded)
            checkIfShowA2shBtn(setIsShowA2hsCta);
    }, [])

    const chemistComponentOnFocus = () => {
        const { navigation }: any = props;
        navigation.addListener("focus", () => {
            // if (global.allowScrollChemistComponent) {
            //     window.scrollTo({
            //         top: global.windowScrollListPageYOffset,
            //         left: 0, behavior: 'auto'
            //     })
            // } else global.allowScrollChemistComponent = false
        });

        // navigation.addListener("blur", () => {
        //     if (!global.allowScrollChemistComponent) {
        //         global.allowScrollChemistComponent = true;
        //     }
        // });
    }

    const chemistStoreSubscription = useCallback(
        debounce(() => getChemistStoreData(), AppTheme.debouceTimeout), [])


    const getChemistStoreData = () => {
        const _reduxState: any = store.getState();
        if (isObjectNotEmpty(_reduxState.pharmacyAllData)) {
            setChemistStoreData(_reduxState.pharmacyAllData)
            if (_reduxState.pharmacyAllData['productCategories']) {
                if (productCategories.length != _reduxState.pharmacyAllData['productCategories'].length)
                    setProductCategories(_reduxState.pharmacyAllData['productCategories'])
            }
            if (_reduxState.pharmacyAllData['dealsData'])
                setDealsList(_reduxState.pharmacyAllData['dealsData'])
            if (_reduxState.pharmacyAllData['posters']) {
                if (chemistAdPosterData.length != _reduxState.pharmacyAllData['posters'].length)
                    setChemistAdPosterData(_reduxState.pharmacyAllData['posters'])
            }
        }
    }

    const filterDealsList = () => {
        if (isObjectNotEmpty(dealsData) && dealsData.inventoryCount > 0) {
            return mergeDealListWithCartData({ deals: dealsData.deals.slice(0, minDealsToShowAllBtn) }).dealsList
        } else return []
    }

    const navigateToStoreProfileView = (chemistStoreData) => {
        props.navigation.navigate(ScreenRoute.chemist_store_profile_view,
            { chemistStoreData: chemistStoreData })
    }

    const navigateToSearchItem = (chemistStoreData) => {
        if (chemistStoreData?.spslEnabled)
            props.navigation.navigate(ScreenRoute.search_deals)
        else props.navigation.navigate(ScreenRoute.search_medicine)
    }

    const updateCartItem = (isAdd, item, quantity = 1) => {
        upsertCartItem(isAdd, item, quantity, {})
    }

    const capturePhoto = (type) => {
        if (chemistStoreLoaded)
            var redirectRoute = ScreenRoute.cart
        else var redirectRoute = ScreenRoute.review_oms_order
        trackMoengageEvents(MoengageEvents.oms_order_started);
        if (type == 'camera')
            pickPrescriptionImageByCamera(props, { redirectRoute: redirectRoute })
        else pickPrescriptionImageByGallery(props, { redirectRoute: redirectRoute })
    }

    // const onSelectDeal = () => { global.windowScrollListPageYOffset = scrollY }

    const showPhotoCaptureModal = () => { setPhotoCaptureModal(true) }
    const closePhotoCaptureModal = () => { setPhotoCaptureModal(false) }

    return (<ScrollView key={'Chemist Screen'}
        showsVerticalScrollIndicator={false}
        style={[AppStyles.bg, { paddingBottom: props?.getBottomPadding() ?? 0 }]}>

        {chemistStoreLoaded ? isShowA2hsCta ?
            <A2HSDashboardView /> : null : <CommonLocationHeader
            pharmacyPage={true} isShowA2hsCta={isShowA2hsCta}
            storeProfileLoaded={chemistStoreLoaded}
            navigation={props.navigation}
            title={getSelectedLocationTitle(selectedLocation)}
            onClickBottomChevron={() => {
                props.navigation.navigate(ScreenRoute.oms_detect_user_location)
            }} onBackPressRoute={ScreenRoute.oms_detect_user_location}
            cartNavigation={() => props.navigation.navigate(ScreenRoute.review_oms_order)} />
        }

        {isObjectNotEmpty(chemistStoreData) ? <ScrollView>
            <View style={[AppStyles.flexRowSpaceBetween, AppStyles.bgWhite,
            AppStyles.px16, AppStyles.pt16, AppStyles.pb8]}>
                <Pressable style={[AppStyles.flexRowStart]}
                    onLongPress={() => { console.log('### long press') }}
                    onPress={() => navigateToStoreProfileView(chemistStoreData)}>
                    {hasChemistProfilePic(chemistStoreData) ? <ChemistStorePicture chemistData={chemistStoreData} /> :
                        <ChemistSiteLogo chemistData={chemistStoreData} />}
                    <View style={[AppStyles.pl16]}>
                        <View style={[AppStyles.flexRowStart, {}]}>
                            <Text style={[TextStyle.text18xb, { maxWidth: AppTheme.appWidth - 32 - 48 - 64, paddingRight: 0 }]}
                                numberOfLines={1} ellipsizeMode={'head'} >
                                {chemistStoreData['pharmacyName']}</Text>
                            <IconView iconStyle={{ marginLeft: 4 }}
                                size={16} icon={'tick_circle_green.svg'} />
                        </View>
                        <Text numberOfLines={1} style={[TextStyle.text14,
                        { marginTop: 4, maxWidth: AppTheme.appWidth - 32 - 48 - 16 }]}>
                            {chemistStoreData['address']}</Text>
                    </View>
                </Pressable>
                {/* Notification View */}
            </View>

            {/* <SecondaryCTA title={'View All'} marginVertical={16}
                backgroundColor={AppTheme.color.background}
                action={() => { props.navigation.navigate(ScreenRoute.search_deals) }} /> */}


            <View style={[AppStyles.bgWhite, AppStyles.p16, { marginTop: 8, }]}>

                <Pressable onPress={() => { navigateToSearchItem(chemistStoreData) }}
                    style={[AppStyles.flexRowStart, AppStyles.borderView, {
                        paddingHorizontal: 16, paddingVertical: 12,
                        alignSelf: "center", width: AppTheme.appWidth - 32
                    }]}>
                    <IconView size={16} icon={'search_blue.svg'} />
                    <Text style={[TextStyle.text16, { marginLeft: 16 }]}>
                        Search for  <FadeTextList /></Text>
                </Pressable>

                {/* {
                    isStoreClosed(chemistStoreData) != null && isStoreClosed(chemistStoreData) &&
                    <View style={[AppStyles.flexRowStart, AppStyles.border12, {
                        marginTop: 16, paddingHorizontal: 16, paddingVertical: 12,
                        alignSelf: "center", width: AppTheme.appWidth - 32,
                        backgroundColor: AppTheme.color.background
                    }]}>
                        <Image style={{ height: 30, width: 38 }}
                            source={{ uri: getImagePath('/images/chemistStore/pharmacyClosed.svg') }} />
                        <Text style={[TextStyle.text12,
                        { flexWrap: "wrap", marginLeft: 16 }]}>
                            <Text style={[TextStyle.text12b]}>
                                Currently Closed: </Text>Store is unable to fulfill your order at this moment.</Text>
                    </View>
                } */}

                {chemistStoreLoaded && chemistAdPosterData.length > 0 &&
                    <AnimatableView animation="fadeIn" style={{ marginTop: 16 }}
                        delay={400} duration={AppTheme.animationDuration}>
                        <CustomCarousel carouselData={chemistAdPosterData}
                            carouselViewBuilder={AdPosterView}
                            paginationViewBuilder={AdPosterPaginationView}
                            viewWidth={284} viewHeight={284}
                            scallingFactor={0.95} scallingFactorOffset={284 - 8}
                            autoPlayInterval={AppTheme.carouselTransitionDuration} /></AnimatableView>}

                <Pressable style={[AppStyles.flexRowSpaceBetween, AppStyles.borderView, AppStyles.bgWhite, AppStyles.p16, AppStyles.m16, {
                    alignSelf: "center", width: AppTheme.appWidth - 32
                }]} onPress={() => { showPhotoCaptureModal() }}>
                    <View>
                        <Text style={[TextStyle.text16b]}>Order Via Photo</Text>
                        <View style={[AppStyles.flexRowStart, { marginTop: 6 }]}>
                            <IconView size={16} icon={'add_camera.svg'} />
                            <Text style={[TextStyle.text12, {
                                marginLeft: 4, width: AppTheme.appWidth - 200
                            }]} ellipsizeMode={"tail"} numberOfLines={1}>
                                Upload the photo of medicines</Text>
                        </View>
                    </View>
                    <PrimaryCTA action={() => showPhotoCaptureModal()}
                        title={'Upload'} paddingVertical={8} width={102} />
                </Pressable>
            </View>

            {productCategories?.length > 0 ? <View style={[AppStyles.bg, { marginBottom: 8 }]}>
                <Text style={[TextStyle.text16b, AppStyles.pl16, AppStyles.mt16]}>
                    Popular Categories</Text>
                <View style={[AppStyles.mx16, AppStyles.mt16, AppStyles.px16, AppStyles.pb16, AppStyles.borderView]}>
                    <ProductCategoriesListView iconSize={(AppTheme.appWidth - 32 - 32 - 32) / 3}
                        categoryList={GetProductCategories(productCategories, {}).slice(0, 6)}
                        action={(category) => props.navigation.navigate(ScreenRoute.search_deals, { category: category })} />
                    {productCategories?.length > 6 && <HorizontalDivider width={AppTheme.appWidth - 32}
                        height={2} marginTop={12} marginBottom={16} />}
                    {productCategories?.length > 6 && <Pressable style={[AppStyles.flexRowCenter]}
                        onPress={() => { props.navigation.navigate(ScreenRoute.product_categories) }}>
                        <Text style={[TextStyle.colorPrimary, TextStyle.text14xb, { paddingRight: 10 }]}>
                            See All Categories</Text>
                        <DownChevron tintColor={AppTheme.color.primary} />
                    </Pressable>}
                </View>
            </View> : null}

            {dealsData.deals ? dealsData.deals.length > 0 ? <AnimatableView
                key={'home_deal_list'} animation="fadeIn" style={[AppStyles.bg]}
                delay={AppTheme.tabTransitionDuration} duration={AppTheme.tabTransitionDuration}>
                <View style={[AppStyles.flexRowSpaceBetween, AppStyles.p16]}>
                    <Text style={[TextStyle.text16b]}>
                        Products in Store</Text>
                    <SeeAllIcon itemCount={dealsData.inventoryCount}
                        action={() => { props.navigation.navigate(ScreenRoute.search_deals) }} />
                </View>
                <FlatList data={filterDealsList()}
                    keyExtractor={(item, index) => "ChemistStore component: deal_view_" + item.dealId + '_index_' + index}
                    renderItem={({ item, index }) => DealView({
                        deal: { ...item, index: index }, from: "chemist store component",
                        navigation: props.navigation,
                        updateCartDealItem: (isAdd, product) =>
                            updateCartItem(isAdd, product)
                    })} snapToAlignment="start" />
                {dealsData.inventoryCount > minDealsToShowAllBtn && <SecondaryCTA
                    marginVertical={16} backgroundColor={AppTheme.color.background}
                    title={getStringWithItemCount(dealsData.inventoryCount, 'See All ', 'See All ')}
                    action={() => { props.navigation.navigate(ScreenRoute.search_deals) }} />}
            </AnimatableView> : <CommonZeroScreen viewStyle={{ marginTop: 64 }}
                screenName={'noProduct'} /> : null}

        </ScrollView> : <ChemistDashboardShimmer />}

        {photoCaptureModal && <PhotoCaptureModel
            showPhotoCaptureModal={photoCaptureModal}
            closeModal={closePhotoCaptureModal}
            capturePhotoAction={(type) => capturePhoto(type)} />}

    </ScrollView>)
}

export default ChemistStoreComponent
